import { ReactNode, useMemo, useRef } from "react";
import { Modal } from "@mui/material";
import FocusLock from "react-focus-lock";
import { ThemeWrapper, useMobileLayout } from "@verity/components";
import { ModalContext, ModalContextType } from "@verity/components/core";
import { useIsInstructor } from "../shared";
import PortalMenu from "./portal-menu";
import PortalTopBar from "./portal-top-bar";
import styles from "./modal-page.module.css";

export default function ModalPage({ children }: { children: ReactNode }) {
	const isInstructor = useIsInstructor();
	const isMobileLayout = useMobileLayout();
	const modalContainer = useRef<HTMLDivElement>(null);
	const modalContext: ModalContextType = useMemo(() => ({ modalContainer }), [modalContainer]);

	// handle focus with FocusLock instead
	return (
		<ModalContext.Provider value={modalContext}>
			<Modal open disableEnforceFocus disableAutoFocus disableRestoreFocus>
				<ThemeWrapper scopedCssBaselineProps={{ className: styles.pageWrapper }}>
					<FocusLock returnFocus className={styles.page}>
						<PortalTopBar />
						<div className={styles.horizontalWrapper}>
							{isInstructor && !isMobileLayout && <PortalMenu />}
							<div className={styles.pageContent}>{children}</div>
							<div className={styles.modalContainer} ref={modalContainer} />
						</div>
					</FocusLock>
				</ThemeWrapper>
			</Modal>
		</ModalContext.Provider>
	);
}
